<template>
    <div class="qr-component-viewer">
        <div class="qr-placeholder"
             :style="{
                 width: item.size + 'px',
                 height: item.size + 'px'
             }">
            <icon-qr style="font-size: 3rem;"></icon-qr>
            <div class="small mt-2">QR Code</div>
            <div class="tiny text-muted">{{pxToCm(item.size)}}cm</div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';
import { pxToCm } from '@/utils/units';

@Options({})
export default class QrCodeComponentViewer extends Vue {
    @Prop() item: OM.QrCodeComponent;

    pxToCm = pxToCm;
}
</script>

<style scoped>
.qr-placeholder {
    border: 2px dashed #dee2e6;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    color: #6c757d;
    box-sizing: border-box;
}

.tiny {
    font-size: 0.7rem;
}
</style>
